module.exports = __webpack_public_path__ + "img/star-pink.39474259.svg";